import { Injectable, inject } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface CommonDialogState {
  isDialogPositionUp: boolean;
}
@Injectable()
export abstract class CommonDialogStore<StoreModel extends CommonDialogState, CloseDialogModel = void> extends ComponentStore<StoreModel> {
  protected readonly dialogRef = inject(DynamicDialogRef);

  protected constructor(public initData: StoreModel) {
    super(initData);
  }

  // SELECTORS ---------------------------------------------------------------------------------------------------------

  readonly isDialogPositionUp$ = this.select((state) => state.isDialogPositionUp);

  // ACTIONS ---------------------------------------------------------------------------------------------------------

  readonly closeDialog = this.effect((closeDialog$: Observable<CloseDialogModel | null>) =>
    closeDialog$.pipe(
      tap((closeDialogData) => {
        this.setIsDialogPositionUp(false);
        setTimeout(() => this.dialogRef.close(closeDialogData), 250);
      }),
    ),
  );

  readonly moveDialogUp = this.effect((runAnimation$: Observable<void>) =>
    runAnimation$.pipe(tap(() => setTimeout(() => this.setIsDialogPositionUp(true), 1))),
  );

  // REDUCERS ---------------------------------------------------------------------------------------------------------

  readonly setIsDialogPositionUp = this.updater((state, isDialogPositionUp: boolean) => ({
    ...state,
    isDialogPositionUp,
  }));
}
